const g = (e) => typeof e == "number" && !isNaN(e) && isFinite(e);
function a(e) {
  return /^(\d{1,6}-)?\d{1,12}\/\d{4}$/.test(e);
}
function l(e, n) {
  return e ? new RegExp(`^\\d{1,${n}}$`).test(e) : !0;
}
function p(e) {
  if (!e) return !0;
  if (!/^\d{8}$/.test(e)) return !1;
  const n = parseInt(e.substring(0, 4)), t = parseInt(e.substring(4, 6)), i = parseInt(e.substring(6, 8)), r = new Date(n, t - 1, i);
  return r.getFullYear() === n && r.getMonth() === t - 1 && r.getDate() === i;
}
function d(e) {
  return typeof e == "number" && e > 0;
}
function k(e) {
  return ["CZK", "EUR", "USD"].includes(e);
}
function u(e, n) {
  return e ? e.length <= n : !0;
}
function x(e) {
  const n = {};
  return e.acc ? a(e.acc) || (n.acc = {
    msg: "Neplatný formát čísla účtu. Očekávaný formát: 000000-000000000000/0000",
    code: "format"
  }) : n.acc = {
    msg: "Číslo účtu je povinné",
    code: "required"
  }, g(e.am) ? d(e.am) || (n.am = {
    msg: "Neplatná částka. Musí být kladné číslo",
    code: "format"
  }) : n.am = {
    msg: "Částka je povinná",
    code: "required"
  }, e.cc ? k(e.cc) || (n.cc = {
    msg: "Neplatný kód měny",
    code: "format"
  }) : n.cc = {
    msg: "Měna je povinná",
    code: "required"
  }, e.vs && !l(e.vs, 10) && (n.vs = {
    msg: "Neplatný variabilní symbol. Musí obsahovat pouze číslice, maximálně 10 znaků",
    code: "format"
  }), e.ss && !l(e.ss, 10) && (n.ss = {
    msg: "Neplatný specifický symbol. Musí obsahovat pouze číslice, maximálně 10 znaků",
    code: "format"
  }), e.ks && !l(e.ks, 4) && (n.ks = {
    msg: "Neplatný konstantní symbol. Musí obsahovat pouze číslice, maximálně 4 znaky",
    code: "format"
  }), e.dt && !p(e.dt) && (n.dt = {
    msg: "Neplatný formát data. Očekávaný formát: RRRRMMDD",
    code: "format"
  }), e.msg && !u(e.msg, 250) && (n.msg = {
    msg: "Zpráva je příliš dlouhá. Maximální délka je 250 znaků",
    code: "format"
  }), e.rec && !u(e.rec, 250) && (n.rec = {
    msg: "Jméno příjemce je příliš dlouhé. Maximální délka je 250 znaků",
    code: "format"
  }), Object.keys(n).length > 0 ? n : null;
}
function v(e) {
  if (!/^(\d+-)?(\d{1,10})\/(\d{4})$/.test(e))
    throw new Error("Invalid account number format");
  let t = "", i = "", r = "";
  if (e.includes("-")) {
    const s = e.split("-");
    t = s[0];
    const m = s[1].split("/");
    i = m[0], r = m[1];
  } else {
    const s = e.split("/");
    i = s[0], r = s[1];
  }
  let o = "";
  t ? o = (t + i).padStart(16, "0") : o = i.padStart(16, "0");
  const f = `${r}${o}CZ00`.replace(
    /[A-Z]/g,
    (s) => (s.charCodeAt(0) - 55).toString()
  );
  let c = 0;
  for (let s = 0; s < f.length; s++)
    c = (c * 10 + parseInt(f[s])) % 97;
  return `CZ${(98 - c).toString().padStart(2, "0")}${r}${o}`;
}
function C(e) {
  let n = "SPD*1.0*";
  const t = v(e.acc);
  return n += `ACC:${t}*`, n += `AM:${e.am.toFixed(2)}*`, n += `CC:${e.cc}*`, e.vs && (n += `VS:${e.vs}*`), e.ss && (n += `SS:${e.ss}*`), e.ks && (n += `KS:${e.ks}*`), e.dt && (n += `DT:${e.dt}*`), e.msg && (n += `MSG:${e.msg}*`), e.rec && (n += `RN:${e.rec}*`), n.slice(0, -1);
}
export {
  C as generateQRString,
  x as validateQRPlatbaRequest
};
//# sourceMappingURL=index.mjs.map
